import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { WellsService } from '../_services/wells.service';
import { SharedFunctionsService } from '../_services/sharedFunctions.service';
import { Location } from '@angular/common';
import { ComponentRefService } from '../_services/componentRef.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { PaginationInstance } from 'ngx-pagination';
import { UserProfileService } from '../../_services/user-profile.service';
import { NavLinkAvailabilityService } from '../../_services/nav-link-availability.service';

@Component({
    selector: 'wells',
    templateUrl: './wells.component.html',
    styleUrls: ['./wells.component.css']
})

export class WellsComponent implements OnInit {
  public wells: WellObjCheck[];
  loading: boolean = false;
  field: string = "";
  fieldid: number = 0;
  company: string = "";
  search: string = "";
  copysearch: string = "";
  wellStatus: Array<any> = [];
  wellInfoAlertClass: string = "";
  wellInfoMessage: string = "";
  wellsSelectedCount: number = 0;
  uneditedWellInfoList: Array<any> | null = null;
  MasterCheckBox: boolean = false;
  submitted: boolean = false;
  fieldName: string = "";
  selectedWell: WellObjCheck = <WellObjCheck>{};
  selectedWellList: WellObjCheck[] = [];
  alertSuccess: string = "alert alert-success";
  alertDanger: string = "alert alert-danger";
  readonly todaysDate: Date = new Date();
  p: number = 1;
  wellBatteries: any;
  wellGasFacilities: any;
  wellSWDList: Array<any> = [];
  sameField: boolean = false;
  multiWell: boolean = false;
  singleWellSWD: boolean = false;
  editWellInfoFrm: UntypedFormGroup;
  wellConFirmString: string = "";
  selectedWellDate: Date | null;
  selectedWellDateString: string = "";
  fieldDateRangeEndString: string = "n/a";
  fieldDateRangeStartString: string = "n/a";
  oneWellIsSWD: boolean | null;
  dummbyValue: any = new Date();
  dateSelectOptions: any = {
    minDate: null,
    maxDate: null
  };
  maxSize: number = 7;
  directionLinks: boolean = true;
  autoHide: boolean = false;
  responsive: boolean = false;
  config: PaginationInstance = {
    id: 'advanced',
    itemsPerPage: 10,
    currentPage: 1
  };
  labels: any = {
    previousLabel: 'Previous',
    nextLabel: 'Next',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };
  sortArrayObj = {
    fieldName: true,
    batteryName: true,
    wellName: true,
    wellID: true,
    currentStatusName: true,
    leaseNumber:true
  }
  gasOutPlateSize: Array<any> = [];
  gasInPlateSize: Array<any> = [];
  wellPlateInfo: Array<any> = [];
  invalidFloatMessage: string = "Please make sure to enter a valid decimal number or leave the input empty.";
  invalidAPIMessage: string = "";
  past30Days: boolean = false;
  up: any;
  oneWellDrilling: boolean = false;
  batteryWarning: boolean = false;

  constructor(private router: Router, public ele: ElementRef, private WellsService: WellsService,
    public location: Location, private fb: UntypedFormBuilder, private CompRefService: ComponentRefService,
    private SharedFunctions: SharedFunctionsService, private ups: UserProfileService,
    private navLinkService: NavLinkAvailabilityService) {
      this.up = this.ups.getUserProfile();
      this.navLinkService.availableLinks$.subscribe(result => {
        result.forEach(app => {
          if (app.baseUrl == "ControlPanel") {
            app.routes.forEach(route => {
              if (route.name == "wells") {
                if (!route.enabled) {
                  this.router.navigate((['/app/ControlPanel/users/user/']));
                }
              } 
          })         
        }
      })
    })
      this.CompRefService.wells = this;
    this.editWellInfoFrm = this.fb.group({
      'EffectiveDate': [null, Validators.compose([Validators.required])],
      'StatusID': null,
      'BatteryID': [null, Validators.compose([this.validBatteryID.bind(this)])],
      'GasFacilityID': null,
      'swdid': null,
      'gasOutMeterDiameter': null,
      'gasOutPlateSize': null,
      'gasOutPlateCoefficient': null,
      'gasOutSpringSize': [null,this.SharedFunctions.validFloatInput],
      'gasInMeterDiameter': null,
      'gasInPlateSize': null,
      'gasInPlateCoefficient': null,
      'gasInSpringSize': [null, this.SharedFunctions.validFloatInput],
      'isGasLiftWell':null,
      'notes': null,
      'newapinumber': [null, Validators.compose([this.SharedFunctions.validAPIstring.bind(this)])],
      'newleasenumber': null,
      'newserialnumber': null,
      'checkHydrate': false
    });
    this.selectedWellDate = new Date();
  }

  refresh() {
    this.ngOnInit();
  }


  ngOnInit() {
    if (typeof window != 'undefined') {
      this.wells = [];
      this.loading = true;
      this.MasterCheckBox = false;
      this.wellsSelectedCount = 0;
      this.selectedWellList = [];
      if (null != this.up) {
        this.company = this.up.currentCompany;
      }

      this.WellsService.getWellsInCompany(this.company).subscribe(result => {
        if (result !== "loading") {
          result.forEach((well: WellObjCheck) => {
            well.isChecked = false;
            if (null !== well.startDate) {
              well.startDate = this.SharedFunctions.getDateForDateOffSet(well.startDate);
            }
          });
          this.wells = result;
          this.loading = false;
        } else {
          this.loading = true
          this.wells = [];
        }
      },
        error => {
          console.log(error)
          this.wells = new Array<any>();
          this.loading = false;
        }
      );


      this.WellsService.getWellsStatuses(this.company)
        .subscribe(result => {
          this.wellStatus = <Array<any>>result;
          localStorage.setItem('wellstatus', JSON.stringify(this.wellStatus))
        },
          error => {
            console.log(error);
          });

      this.WellsService.getPlateInfo(this.company)
        .subscribe(result => {
          this.wellPlateInfo = result;
        },
          error => {
            console.log(error);
          })
      this.invalidAPIMessage = this.SharedFunctions.apiValidStringAlert;
    }
  }

  onDateChanged() {
    let control = this.editWellInfoFrm.get('EffectiveDate')
    if (null != control) {
      control.valueChanges.subscribe(result => {
        this.getFieldDatasheetDateRange(this.selectedWell.wellID)
      })
    }

  }
  
  statusChanged() {
    this.batteryWarning = false;

    if (this.multiWell) {
      if (this.editWellInfoFrm.controls['BatteryID'].value == null) {
        this.editWellInfoFrm.controls['BatteryID'].patchValue("noChange");
      }
      if (this.editWellInfoFrm.controls['BatteryID'].value == "noChange" && this.oneWellDrilling && (this.editWellInfoFrm.controls['StatusID'].value != 6 && this.editWellInfoFrm.controls['StatusID'].value != "noChange")) {
        this.batteryWarning = true;
      }
    } else {
      if (this.editWellInfoFrm.controls['BatteryID'].value == null || this.editWellInfoFrm.controls['BatteryID'].value == 0) {
        this.editWellInfoFrm.controls['BatteryID'].patchValue(this.wellBatteries[0].batteryID);
      }
    }
    this.editWellInfoFrm.controls['checkHydrate'].patchValue(false);
  }

  modalLostFocus(divName: string, form: any) {
    let element = document.getElementById(divName);
    if (element != null) {
      if (element.style.display == "none") {
        this.resetForm(divName, form);
      }
    }
  }

  resetForm(divName: string, form: any) {

    switch (divName) {
      case "editwellinfomodal":
        this.oneWellIsSWD = null;
        this.hideCalendar();
        this.singleWellSWD = false;
        this.editWellInfoFrm.controls['GasFacilityID'].enable();
        this.editWellInfoFrm.controls['swdid'].enable();
        this.wellInfoAlertClass = "alert";
        this.wellInfoMessage = "";
        this.uneditedWellInfoList = null;
        this.wellBatteries = [{}];
        this.selectedWell = <WellObjCheck>{};

        let el = document.getElementById("WellInfoCancel")
        if (el != null) {
          el.innerHTML = "Cancel";
        }
        break;

      default:
        break;
    }
    this.oneWellDrilling = false;
    this.multiWell = false;
    this.batteryWarning = false;
    this.clearDate();
  }

  setDate(): void {
    this.dateSelectOptions.maxDate = this.todaysDate;
    let activeDate: Date;
    
    if (!this.multiWell && null != this.selectedWell.startDate && !this.checkEffectiveDate30Days()) {
      let untilDate: Date = new Date(this.selectedWell.startDate.toDateString());
      untilDate.setDate(this.selectedWell.startDate.getDate());
      this.dateSelectOptions.minDate = untilDate;

      this.returnSelectedWellDate();
    }
    else if (!this.multiWell && (null == this.selectedWell.startDate || this.checkEffectiveDate30Days())) {
      activeDate = new Date();
      activeDate.setDate(new Date().getDate() - 29);
      this.returnSelectedWellDate();

      this.dateSelectOptions.minDate = activeDate;
    }
    else if (this.multiWell) {
      activeDate = new Date();
      activeDate.setDate(new Date().getDate() - 29);
      this.returnSelectedWellDate();

      this.dateSelectOptions.minDate = activeDate;
    }
  }

  onCalendarOpen() {
    var FormDate: Date = this.editWellInfoFrm.controls["EffectiveDate"].value;
    if (FormDate == null || FormDate == this.selectedWellDate) {
      FormDate = this.todaysDate;
      this.editWellInfoFrm.patchValue({
        "EffectiveDate": this.todaysDate
      })
    }
  }
  
  checkEffectiveDate30Days() {
    if (null != this.selectedWell.startDate) {
      let monthAgo: Date = new Date(new Date().setDate(new Date().getDate() - 30));
      if (monthAgo.getTime() > this.selectedWell.startDate.getTime()) {
        this.past30Days = true;
        return true;
      }
      this.past30Days = false;
      return false
    }
    this.past30Days = true;
    return true
  }

  orderList(columnName: string) {
    this.SharedFunctions.sortArray(this.wells, columnName, this.sortArrayObj);
    if (this.sortArrayObj[columnName]) {
      this.sortArrayObj[columnName] = false;
    } else {
      this.sortArrayObj[columnName] = true;
    }
    this.dummbyValue = new Date();
  }

  hideCalendar() {
    let calendar = document.getElementById('mydate');
    if (null != calendar) {
      calendar.style.display = "false";
    }
  }

  getCopyOfDateSelectOptions(): any {
    return JSON.parse(JSON.stringify(this.dateSelectOptions));
  }

  clearDate(): void {
    this.editWellInfoFrm.patchValue({ EffectiveDate: null });
    this.dateSelectOptions.minDate = null;
    this.dateSelectOptions.maxDate = null;
    this.selectedWellDate = new Date();
  }

  multiWellFunc() {
    if (this.wellsSelectedCount === 1) {
      let wellIndex = this.wells.findIndex(well => well.wellID == this.selectedWellList[0].wellID ? true : false)
      this.callWellFunction(this.wells[wellIndex]);
    }
    else {
      this.multiWell = true;
      this.editWellInfoFrm.reset({
        'EffectiveDate': null,
        'StatusID': "noChange",
        'BatteryID': "noChange",
        'notes': null,
        'GasFacilityID': "noChange",
        'swdid': "noChange",
        'gasOutMeterDiameter': null,
        'gasOutPlateSize': null,
        'gasOutPlateCoefficient': null,
        'gasOutSpringSize': null,
        'gasInMeterDiameter': null,
        'gasInPlateSize': null,
        'gasInPlateCoefficient': null,
        'gasInSpringSize': null,
        'isGasLiftWell': null,
        'newapinumber': null,
        'newleasenumber': null,
        'newserialnumber': null,
      });
      this.checkFields();
      this.setDate();
      this.getFieldBatteries();
      this.getGasFacilities();
      this.setPlateDiameterDropDown(this.selectedWell.gasOutMeterDiameter, false, true);
      this.setPlateSizeCoef(this.selectedWell.gasOutMeterDiameter, this.selectedWell.gasOutPlateSize, false);
      this.setPlateDiameterDropDown(this.selectedWell.gasInMeterDiameter, true, true);
      this.setPlateSizeCoef(this.selectedWell.gasInMeterDiameter, this.selectedWell.gasInPlateSize, true);
    }
  }

  setSelectedWell(well: any) {
    this.selectedWell = <WellObjCheck>well;
    this.returnNullOrTrimmedValue(this.selectedWell.api);
    this.returnNullOrTrimmedValue(this.selectedWell.leaseNumber);
    this.returnNullOrTrimmedValue(this.selectedWell.serialNumber);
    this.returnNullOrTrimmedValue(this.selectedWell.notes);
  }

  resetSingleWell() {
    this.field = this.selectedWell.fieldName;
    this.selectedWellDate = this.selectedWell.startDate;
    this.fieldid = this.selectedWell.fieldID;
    this.editWellInfoFrm.reset({
      'EffectiveDate': this.todaysDate,
      'StatusID': this.selectedWell.currentStatusID,
      'BatteryID': this.selectedWell.batteryID,
      'notes': this.selectedWell.notes,
      'GasFacilityID': this.selectedWell.gasFacilityID,
      'swdid': this.selectedWell.swdid,
      'gasOutMeterDiameter': null != this.selectedWell.gasOutMeterDiameter?Math.round(this.selectedWell.gasOutMeterDiameter):null,
      'gasOutPlateSize': this.selectedWell.gasOutPlateSize,
      'gasOutPlateCoefficient': this.selectedWell.gasOutPlateCoefficient,
      'gasOutSpringSize': this.selectedWell.gasOutSpringSize,
      'gasInMeterDiameter': this.selectedWell.gasInMeterDiameter,
      'gasInPlateSize': this.selectedWell.gasInPlateSize,
      'gasInPlateCoefficient': this.selectedWell.gasInPlateCoefficient,
      'gasInSpringSize': this.selectedWell.gasInSpringSize,
      'newapinumber': this.returnNullOrTrimmedValue(this.selectedWell.api),
      'newleasenumber': this.returnNullOrTrimmedValue(this.selectedWell.leaseNumber),
      'newserialnumber': this.returnNullOrTrimmedValue(this.selectedWell.serialNumber),
      'isGasLiftWell': this.selectedWell.isGasLiftWell
    });
    this.setPlateDiameterDropDown(this.selectedWell.gasOutMeterDiameter, false, true);
    this.setPlateSizeCoef(this.selectedWell.gasOutMeterDiameter, this.selectedWell.gasOutPlateSize, false);
    this.setPlateDiameterDropDown(this.selectedWell.gasInMeterDiameter, true, true);
    this.setPlateSizeCoef(this.selectedWell.gasInMeterDiameter, this.selectedWell.gasInPlateSize, true);
  }

  returnNullOrTrimmedValue(value: string) {
    return value == null ? null : value.trim()
  }

  callWellFunction(well: any) {
    this.openEditWellStatusModal(well)

    if (!this.multiWell) {
      this.resetSingleWell();
    }
    this.setDate()
    this.getFieldBatteries();
    this.getGasFacilities();
    if (!this.multiWell) {
      this.returnSelectedWellDate();
      this.checkIfWellIsSWD();
    }
  }

  openEditWellStatusModal(well: any) {
    if (!this.multiWell) {
      this.selectedWell = <WellObjCheck>well;
    }
  }

  setWellStatusFront(statusId: number, newEffectiveDate: any) {
    this.wellStatus.forEach((item: any) => {
      if (item.id === statusId) {
        if (null != this.selectedWell) {
          this.selectedWell.currentStatusName = item.name;
          this.selectedWell.currentStatusID = statusId;
          this.selectedWell.startDate = newEffectiveDate;
        }
        else {
          this.selectedWellList[0].currentStatusName = item.name;
          this.selectedWellList[0].currentStatusID = statusId;
          this.selectedWellList[0].startDate = newEffectiveDate;
        }
      }
    })
  }

  selectAllClicked() {
    let checked: number = 0;
    let ChildrenCheckBoxes: HTMLCollectionOf<Element> = document.getElementsByClassName("ChildCheckBox");
    let checkbox: HTMLInputElement
    for (let i = 0; i < ChildrenCheckBoxes.length; i++) {
      checkbox = <HTMLInputElement>ChildrenCheckBoxes[i]
      let wellIndex = this.wells.findIndex(w => checkbox.id == String(w.wellID));
      if (this.MasterCheckBox) {
        if (!this.wells[wellIndex].isChecked) {
          this.wells[wellIndex].isChecked = true;
          this.selectedWellList.push(Object.assign({}, this.wells[wellIndex])) 
          checked = checked + 1
        }
      }
      else {
        if (checkbox.checked) {
          this.wells[wellIndex].isChecked = false;
          let selectedWellListIndex = this.selectedWellList.findIndex(sw => this.wells[wellIndex].wellID == sw.wellID)
          this.selectedWellList.splice(selectedWellListIndex, 1);
          checked = checked + 1
        }
      }   
    }
    if (this.MasterCheckBox == true) {
      this.wellsSelectedCount = this.wellsSelectedCount + checked;
    }
    else {
      this.wellsSelectedCount = this.wellsSelectedCount - checked;
    }

  }

  wellSelected(well: WellObjCheck) {
    let index = this.selectedWellList.findIndex(wellitem => wellitem.wellID === well.wellID)
    if (well.isChecked) {
      this.wellsSelectedCount += 1;
      this.selectedWellList.push(Object.assign({},well))           
      this.selectedWell = <WellObjCheck>{};
      if (this.wellsSelectedCount < 0) {
        this.wellsSelectedCount = 1;
      }
    }
    else {
      this.wellsSelectedCount -= 1;     
      this.selectedWellList.splice(index, 1)
      if (this.wellsSelectedCount < 0) {
        this.wellsSelectedCount = 0;
      }
    }
    if (this.wellsSelectedCount == 0) {
      this.MasterCheckBox = false
      this.selectedWellList = [];
    }
    

  }

  checkIfWellIsSWD(): any {
    let check: boolean = false;
    this.wellSWDList = []
    let w: any = {};
    if (this.multiWell) {
      this.selectedWellList.forEach(well => {
        if (well.injectionWell == true) { 
          check = true;
        this.editWellInfoFrm.controls['GasFacilityID'].disable();
        this.editWellInfoFrm.controls['swdid'].disable();
}
      })
    }
    else {
      if (this.selectedWell.injectionWell == true) {
        check = true;
        this.editWellInfoFrm.controls['GasFacilityID'].disable();
        this.editWellInfoFrm.controls['swdid'].disable();
      }
    }

    this.WellsService.getSWDInField(this.company, this.fieldid)
      .subscribe(result => {
        result.forEach((well: any) => {
          w = {};
          w.wellID = well.wellID;
          w.wellName = well.wellName;
          this.wellSWDList.push(w);
        })

        if (check ? this.oneWellIsSWD = true : this.oneWellIsSWD = false)        
        return check;
      },
        error => {
          console.log(error);
          return check;
        });
  }

  convertDate(dateObject: any) {
    let date: Date = new Date(dateObject.date.year, dateObject.date.month, dateObject.date.day);
    return date;
  }

  batterySelected(battID: number) {
    let result: boolean = false;
    if (!this.multiWell) {
      if (this.selectedWell.batteryID == battID) {
        result = true;
      }
    }
    return result;
  }

  batteryChanged() {
    this.batteryWarning = false;
    if (this.multiWell && this.oneWellDrilling) {
      if (this.editWellInfoFrm.controls['StatusID'].value != 6 && this.editWellInfoFrm.controls['StatusID'].value != "noChange") {
        if (this.editWellInfoFrm.controls['BatteryID'].value == "noChange") {
          this.batteryWarning = true;
        } else {
          this.batteryWarning = false;
        }
      }
    }
  }

  gasFacilitySelected(gasID: number) {
    let result: boolean = false;
    if (!this.multiWell) {
      if (this.selectedWell.gasFacilityID == gasID) {
        result = true;
      }
    }
    return result;
  }

  swdSelected(swdid:number) {
    let result: boolean = false;
    if (!this.multiWell) {
      if (this.selectedWell.swdid == swdid) {
        result = true;
      }
    }
    return result;
  }

  editWellInfo(form: UntypedFormGroup) {
    let SelectedWellClone: Array<WellObjCheck> = this.checkWellObj(form);

    SelectedWellClone.forEach(well => {
      if (well.gasOutMeterDiameter === Math.round(this.selectedWell.gasOutMeterDiameter)) {
        well.gasOutMeterDiameter = this.selectedWell.gasOutMeterDiameter
      }
    })

    if (confirm(this.wellConFirmString)) {
      let input = form.value;
      if (input.StatusID === 6) { input.checkHydrate = false };
      this.submitted = true;
      this.WellsService.updateWellInformation(this.company, SelectedWellClone, this.editWellInfoFrm.controls['EffectiveDate'].value, input.checkHydrate).subscribe((result: any) => {
        if (typeof result === "string") {
          this.wellInfoAlertClass = this.alertSuccess;
          this.wellInfoMessage = result;
          this.submitted = false;
          this.setWellStatusFront(Number(input['StatusID']), input['EffectiveDate']);
          if (!this.multiWell || (this.multiWell && SelectedWellClone.length == 1)) {
            this.updateWell(0);
            this.editWellInfoFrm.controls['EffectiveDate'].reset();
            this.resetSingleWell();
            this.setDate();
            let foundwell: boolean = false;
            this.selectedWellList.forEach((wi, index) => {
              if (!foundwell) { 
              if (wi.wellID == SelectedWellClone[0].wellID) {
                this.selectedWellList.splice(index, 1);
                this.wellsSelectedCount -= 1
                foundwell = true;
              }
              } 
            })
          }
          else
          {
            this.wellInfoMessage = this.wellInfoMessage.replace(".", ' for the following wells: ')
            for (let i = 0; i < this.selectedWellList.length; ++i) {               
              if (i + 1 != this.selectedWellList.length) {
                this.wellInfoMessage += this.selectedWellList[i].wellName + ", ";
              } else {
                this.wellInfoMessage += this.selectedWellList[i].wellName + ".";
              }
              this.updateWell(i);
            }
            this.editWellInfoFrm.controls['StatusID'].patchValue("noChange");
            this.editWellInfoFrm.controls['BatteryID'].patchValue("noChange");
            this.editWellInfoFrm.controls['GasFacilityID'].patchValue("noChange");
            this.editWellInfoFrm.controls['swdid'].patchValue("noChange");
            this.editWellInfoFrm.controls['notes'].reset();
            this.editWellInfoFrm.controls['EffectiveDate'].reset();
            this.wellsSelectedCount = 0;
            this.MasterCheckBox = false;
            this.selectedWellList = [];
          }

          let el = document.getElementById("WellInfoCancel")
          if (el != null) {
            el.innerHTML = "Close";
          }
        }
        else {
          this.wellInfoAlertClass = this.alertDanger;
          this.wellInfoMessage = "There was an error editing the status of one or more wells"
          this.submitted = false;
          this.uneditedWellInfoList = result;
          let foundWell: boolean = false;

          for (let i = 0; i < this.selectedWellList.length; ++i) {
            if (this.uneditedWellInfoList != null) {
              foundWell = false
              this.uneditedWellInfoList.forEach((wellitem) => {
                if (!foundWell) { 
                  if (this.selectedWellList[i].wellID === wellitem.wellID) {
                    if (wellitem.success) {
                      this.updateWell(i);
                      this.selectedWellList.splice(i, 1);
                      --i;
                      this.wellsSelectedCount -= 1;
                      foundWell = true;
                    }
                  }
                }
              })
            }
          };
        };
      },
        (error: string) => {
          this.wellInfoAlertClass = this.alertDanger;
          this.wellInfoMessage = error;
          this.submitted = false;
          let el = document.getElementById("WellInfoCancel")
          if (el != null) {
            el.innerHTML = "Close";
          }
        });
    }
  }

  updateWell(i: number) {
    if (this.multiWell) {
      let wellIndex = this.wells.findIndex(well => well.wellID == this.selectedWellList[i].wellID && well.isChecked ? true : false)
      this.wells[wellIndex].isChecked = false;

      this.selectedWellList[i].isChecked = false;
      if (this.editWellInfoFrm.controls['StatusID'].dirty && this.editWellInfoFrm.controls['StatusID'].value != "noChange") {
        this.wells[wellIndex].currentStatusID = this.editWellInfoFrm.controls['StatusID'].value;
        this.wells[wellIndex].currentStatusName = this.getStatusName(Number(this.editWellInfoFrm.controls['StatusID'].value));

        this.selectedWellList[i].currentStatusID = this.editWellInfoFrm.controls['StatusID'].value;
        this.selectedWellList[i].currentStatusName = this.getStatusName(Number(this.editWellInfoFrm.controls['StatusID'].value));
      }
      if (this.editWellInfoFrm.controls['BatteryID'].dirty && this.editWellInfoFrm.controls['BatteryID'].value != "noChange") {
        this.wells[wellIndex].batteryID = this.editWellInfoFrm.controls['BatteryID'].value;
        this.wells[wellIndex].batteryName = this.getBatteryName(Number(this.editWellInfoFrm.controls['BatteryID'].value));

        this.selectedWellList[i].batteryID = this.editWellInfoFrm.controls['BatteryID'].value;
        this.selectedWellList[i].batteryName = this.getBatteryName(Number(this.editWellInfoFrm.controls['BatteryID'].value));
      }
      if (this.editWellInfoFrm.controls['GasFacilityID'].dirty) {
        this.wells[wellIndex].gasFacilityID = this.editWellInfoFrm.controls['GasFacilityID'].value;
        this.wells[wellIndex].gasFacilityName = this.getGasFacilityName(Number(this.editWellInfoFrm.controls['GasFacilityID'].value));

        this.selectedWellList[i].gasFacilityID = this.editWellInfoFrm.controls['GasFacilityID'].value;
        this.selectedWellList[i].gasFacilityName = this.getGasFacilityName(Number(this.editWellInfoFrm.controls['GasFacilityID'].value));
      }
      if (this.editWellInfoFrm.controls['swdid'].dirty) {
        this.wells[wellIndex].swdid = this.editWellInfoFrm.controls['swdid'].value;
        this.wells[wellIndex].swdName = this.getSWDName(Number(this.editWellInfoFrm.controls['swdid'].value));

        this.selectedWellList[i].swdid = this.editWellInfoFrm.controls['swdid'].value;
        this.selectedWellList[i].swdName = this.getSWDName(Number(this.editWellInfoFrm.controls['swdid'].value));
      }
      
      this.wells[wellIndex].notes = this.editWellInfoFrm.controls['notes'].value;
      this.selectedWellList[i].notes = this.editWellInfoFrm.controls['notes'].value;
      this.wells[wellIndex].startDate = this.editWellInfoFrm.controls['EffectiveDate'].value;
      this.selectedWellList[i].startDate = this.editWellInfoFrm.controls['EffectiveDate'].value;      
    }
    if (!this.multiWell) {
      let wellIndex = this.wells.findIndex(well => well.wellID == this.selectedWell.wellID ? true : false)
      this.selectedWell.startDate = this.editWellInfoFrm.controls['EffectiveDate'].value;
      this.selectedWell.isChecked = false;
      this.wells[wellIndex].isChecked = false;

      if (this.editWellInfoFrm.controls['StatusID'].dirty) {
        this.selectedWell.currentStatusID = this.editWellInfoFrm.controls['StatusID'].value;
        this.selectedWell.currentStatusName = this.getStatusName(Number(this.editWellInfoFrm.controls['StatusID'].value));
      }
      if (this.editWellInfoFrm.controls['BatteryID'].value != this.selectedWell.batteryID) {
        this.selectedWell.batteryID = this.editWellInfoFrm.controls['BatteryID'].value;
        this.selectedWell.batteryName = this.getBatteryName(Number(this.editWellInfoFrm.controls['BatteryID'].value));
      }
      if (this.editWellInfoFrm.controls['GasFacilityID'].dirty) {
        this.selectedWell.gasFacilityID = this.editWellInfoFrm.controls['GasFacilityID'].value;
        this.selectedWell.gasFacilityName = this.getGasFacilityName(Number(this.editWellInfoFrm.controls['GasFacilityID'].value));
      }
      if (this.editWellInfoFrm.controls['swdid'].dirty) {
        this.selectedWell.swdid = this.editWellInfoFrm.controls['swdid'].value;
        this.selectedWell.swdName = this.getSWDName(Number(this.editWellInfoFrm.controls['swdid'].value));
      }
      if (this.editWellInfoFrm.controls['isGasLiftWell'].dirty) {
        if (this.editWellInfoFrm.controls['isGasLiftWell'].value) { this.selectedWell.isGasLiftWell = 1 }
        if (!this.editWellInfoFrm.controls['isGasLiftWell'].value) { this.selectedWell.isGasLiftWell = 0 }
      } 
      if (this.editWellInfoFrm.controls['gasOutMeterDiameter'].dirty) {
        this.selectedWell.gasOutMeterDiameter = this.editWellInfoFrm.controls['gasOutMeterDiameter'].value;
      }
      if (this.editWellInfoFrm.controls['gasOutPlateSize'].value != this.selectedWell.gasOutPlateSize) {
        this.selectedWell.gasOutPlateSize = this.editWellInfoFrm.controls['gasOutPlateSize'].value;
      }
      if (this.editWellInfoFrm.controls['gasOutPlateCoefficient'].value != this.selectedWell['gasOutPlateCoefficient']) {
        this.selectedWell.gasOutPlateCoefficient = this.editWellInfoFrm.controls['gasOutPlateCoefficient'].value;
      }
      if (this.editWellInfoFrm.controls['gasOutSpringSize'].dirty) {
        this.selectedWell.gasOutSpringSize = this.editWellInfoFrm.controls['gasOutSpringSize'].value;
      }
      if (this.editWellInfoFrm.controls['gasInMeterDiameter'].dirty) {
        this.selectedWell.gasInMeterDiameter = this.editWellInfoFrm.controls['gasInMeterDiameter'].value;
      }
      if (this.editWellInfoFrm.controls['gasInPlateSize'].value != this.selectedWell['gasInPlateSize']) {
        this.selectedWell.gasInPlateSize = this.editWellInfoFrm.controls['gasInPlateSize'].value;
      }
      if (this.editWellInfoFrm.controls['gasInPlateCoefficient'].value != this.selectedWell['gasInPlateCoefficient']) {
        this.selectedWell.gasInPlateCoefficient = this.editWellInfoFrm.controls['gasInPlateCoefficient'].value;
      }
      if (this.editWellInfoFrm.controls['gasInSpringSize'].dirty) {
        this.selectedWell.gasInSpringSize = this.editWellInfoFrm.controls['gasInSpringSize'].value;
      }
      if (this.editWellInfoFrm.controls['newleasenumber'].dirty) {
        this.selectedWell.leaseNumber = this.editWellInfoFrm.controls['newleasenumber'].value;
      }
      if (this.editWellInfoFrm.controls['newserialnumber'].dirty) {
        this.selectedWell.serialNumber = this.editWellInfoFrm.controls['newserialnumber'].value;
      }
      if (this.editWellInfoFrm.controls['newapinumber'].dirty) {
        this.selectedWell.api = this.editWellInfoFrm.controls['newapinumber'].value;
      }
      if (this.editWellInfoFrm.controls['notes'].dirty) {
        this.selectedWell.notes = this.editWellInfoFrm.controls['notes'].value;
      }
    }
  }



  getFieldBatteries() {
    this.WellsService.getBatteriesInField(this.company, this.fieldid)
      .subscribe(result => {
        this.wellBatteries = result;
      },
        error => {
          console.log(error);
        })
  }

  getGasFacilities() {
    this.WellsService.getGasFacilitiesInField(this.company, this.fieldid)
      .subscribe(result => {
        this.wellGasFacilities = result;
      },
        error => {
          console.log(error);
        })
  }

  getStatusName(id: number): string {
    let name: string = "";
    this.wellStatus.forEach((item) => {
      if (id === item.id) {
        name = item.name;
      }
    });
    return name;
  }

  getBatteryName(id: number): string {
    let name: string = "";
    this.wellBatteries.forEach((item: any) => {
      if (item.batteryID === id) {
        name = item.batteryName;
      }
    });
    return name;
  }

  getGasFacilityName(id: number): string {
    let name: string = "";
    this.wellGasFacilities.forEach((item: any) => {
      if (item.gasFacilityID === id) {
        name = item.gasFacilityName;
      }
    });
    return name;
  }

  getSWDName(id: number): string {
    let name: string = "";
    this.wellSWDList.forEach((item: any) => {
      if (id == item.wellID) {
        name = item.wellName;
      }
    });

    return name;
  }

  getFieldDatasheetDateRange(id: number) {
    if (null != this.editWellInfoFrm.controls['EffectiveDate'].value) {
      let date = this.editWellInfoFrm.controls['EffectiveDate'].value;
      let fieldDate = this.WellsService.getFieldDatasheetDateRange(this.company, date, this.todaysDate, id)
        .subscribe(result => {
          if (null != result[0]) {
           let fieldDSStartDate = this.SharedFunctions.getDateForDateOffSet(result[0]);
             this.fieldDateRangeStartString = fieldDSStartDate.toDateString();
          } else {                                                                                       
            this.fieldDateRangeStartString = "n/a";
          }

          if (null != result[1]) {
            let fieldDSEndDate = this.SharedFunctions.getDateForDateOffSet(result[1]);
            this.fieldDateRangeEndString = fieldDSEndDate.toDateString();
          } else {
            this.fieldDateRangeEndString = "n/a";
          }
        },
          error => {
            console.log(error);
          });
    }
  }

  checkFields() {
    let sf: boolean = true;
    let fID: number = 0;
    let wellfield: string = "";
    this.selectedWellList.forEach((well, index) => {
      if (index === 0) {
        wellfield = well.fieldName
        fID = well.fieldID
      }
      else {
        if (wellfield != well.fieldName) {
          sf = false;
        }
      }
    });
    if (sf) {
      this.field = wellfield;
      this.fieldid = fID;
      this.checkIfWellIsSWD();
    }
    this.sameField = sf;
  }

  returnSelectedWellDate() {
    let date: string = "N/A";
    if (null != this.selectedWellDate) {
      var standardDate = new Date(this.selectedWellDate.toDateString())
      date = String(standardDate.getMonth() + 1) + ' / ' + String(standardDate.getDate()) + ' / ' + String(standardDate.getFullYear());
    }
    this.selectedWellDateString = date;
    if (null != this.selectedWell) { this.getFieldDatasheetDateRange(this.selectedWell.wellID) };
    return date;
  }

  checkWellObj(form: UntypedFormGroup): any {
    let add: WellObjCheck;
    let dirty: boolean = false;
    let confirmationString: string = "You are about to submit the following changes for the well(s):" + " \n " + "Effective Date: " + this.editWellInfoFrm.controls['EffectiveDate'].value.toDateString();
    let returnWellArray: Array<any> = [];
    let oldValue: string = "";
    let newValue: string = "";
    if (!this.multiWell) {
      let selectedWellClone: WellObjCheck = Object.assign({}, this.selectedWell)
      selectedWellClone.startDate = this.editWellInfoFrm.controls['EffectiveDate'].value;
      selectedWellClone.injectionWell = this.selectedWell.injectionWell;
      if (this.editWellInfoFrm.controls['StatusID'].value !== this.selectedWell.currentStatusID && this.editWellInfoFrm.controls['StatusID'].value !== "noChange") {
        selectedWellClone.currentStatusName = this.getStatusName(Number(this.editWellInfoFrm.controls['StatusID'].value));
        selectedWellClone.currentStatusID = this.editWellInfoFrm.controls['StatusID'].value;
        confirmationString = confirmationString + " \n " + "Status: " + this.selectedWell.currentStatusName + " => " + selectedWellClone.currentStatusName;
      }
      if (this.editWellInfoFrm.controls['checkHydrate'].value == true) {
        if (this.editWellInfoFrm.controls['StatusID'].value !== this.selectedWell.currentStatusID && this.editWellInfoFrm.controls['StatusID'].value == 1) {
          confirmationString = confirmationString + " \n " + `Create the well data from ${this.fieldDateRangeStartString} to ${this.fieldDateRangeEndString}`;
        } else {
          confirmationString = confirmationString + " \n " + `Delete the well data from ${this.fieldDateRangeStartString} to ${this.fieldDateRangeEndString}`;
        }
      }
      if (this.editWellInfoFrm.controls['BatteryID'].value !== this.selectedWell.batteryID && this.editWellInfoFrm.controls['BatteryID'].value !== "noChange") {
        oldValue = this.selectedWell.batteryName == null ? "None" : this.selectedWell.batteryName;
        newValue = this.editWellInfoFrm.controls['BatteryID'].value == null ? "None" : this.getBatteryName(Number(this.editWellInfoFrm.controls['BatteryID'].value));
        selectedWellClone.batteryName = newValue;
        selectedWellClone.batteryID = this.editWellInfoFrm.controls['BatteryID'].value;
        confirmationString = confirmationString + " \n " + "Battery: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['GasFacilityID'].value !== this.selectedWell.gasFacilityID && this.editWellInfoFrm.controls['GasFacilityID'].value !== "noChange") {
        oldValue = this.selectedWell.gasFacilityName == null ? "None" : this.selectedWell.gasFacilityName;
        newValue = this.editWellInfoFrm.controls['GasFacilityID'].value == null ? "None" : this.getGasFacilityName(Number(this.editWellInfoFrm.controls['GasFacilityID'].value));
        selectedWellClone.gasFacilityName = newValue;
        selectedWellClone.gasFacilityID = this.editWellInfoFrm.controls['GasFacilityID'].value;
        confirmationString = confirmationString + " \n " + "Gas Facility: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['swdid'].value !== this.selectedWell.swdid && this.editWellInfoFrm.controls['swdid'].value !== "noChange") {
        oldValue = this.selectedWell.swdName == null ? "None" : this.selectedWell.swdName;
        newValue = this.editWellInfoFrm.controls['swdid'].value == null ? "None" : this.getSWDName(Number(this.editWellInfoFrm.controls['swdid'].value))
        selectedWellClone.swdName = newValue;
        selectedWellClone.swdid = this.editWellInfoFrm.controls['swdid'].value;
        confirmationString = confirmationString + " \n " + "SWD: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['isGasLiftWell'].value !== this.selectedWell.isGasLiftWell) {
        oldValue = this.selectedWell.isGasLiftWell == 1 ? "Yes" : "No";
        newValue = this.editWellInfoFrm.controls['isGasLiftWell'].value ? "Yes" : "No";
        confirmationString = confirmationString + " \n " + "Is Gas Lift: " + oldValue + " => " + newValue;
      }

      if (this.editWellInfoFrm.controls['gasOutMeterDiameter'].value !== (this.selectedWell.gasOutMeterDiameter == null ? null : Math.round(this.selectedWell.gasOutMeterDiameter))) {
        selectedWellClone.gasOutMeterDiameter = this.editWellInfoFrm.controls['gasOutMeterDiameter'].value;
        oldValue = this.selectedWell.gasOutMeterDiameter == null ? "None" : String(this.selectedWell.gasOutMeterDiameter);
        newValue = selectedWellClone.gasOutMeterDiameter == null ? "None" : String(selectedWellClone.gasOutMeterDiameter);
        confirmationString = confirmationString + " \n " + "Gas Out Meter Diameter: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasOutPlateSize'].value !== this.selectedWell.gasOutPlateSize) {
        selectedWellClone.gasOutPlateSize = this.editWellInfoFrm.controls['gasOutPlateSize'].value;
        oldValue = this.selectedWell.gasOutPlateSize == null ? "None" : String(this.selectedWell.gasOutPlateSize)
        newValue = selectedWellClone.gasOutPlateSize == null ? "None" : String(selectedWellClone.gasOutPlateSize);
        confirmationString = confirmationString + " \n " + "Gas Out Plate Size: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasOutPlateCoefficient'].value !== this.selectedWell.gasOutPlateCoefficient) {
        selectedWellClone.gasOutPlateCoefficient = this.editWellInfoFrm.controls['gasOutPlateCoefficient'].value;
        oldValue = this.selectedWell.gasOutPlateCoefficient == null ? "None" : String(this.selectedWell.gasOutPlateCoefficient);
        newValue = selectedWellClone.gasOutPlateCoefficient == null ? "None" : String(selectedWellClone.gasOutPlateCoefficient);
        confirmationString = confirmationString + " \n " + "Gas Out Plate Coefficient: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasOutSpringSize'].value !== this.selectedWell.gasOutSpringSize) {
        selectedWellClone.gasOutSpringSize = this.editWellInfoFrm.controls['gasOutSpringSize'].value;
        oldValue = this.selectedWell.gasOutSpringSize == null ? "None" : String(this.selectedWell.gasOutSpringSize);
        newValue = this.editWellInfoFrm.controls['gasOutSpringSize'].value == null ? "None" : String(selectedWellClone.gasOutSpringSize);
        confirmationString = confirmationString + " \n " + "Gas Out Spring Size: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasInMeterDiameter'].value !== this.selectedWell.gasInMeterDiameter) {
        selectedWellClone.gasInMeterDiameter = this.editWellInfoFrm.controls['gasInMeterDiameter'].value;
        oldValue = this.selectedWell.gasInMeterDiameter == null ? "None" : String(this.selectedWell.gasInMeterDiameter);
        newValue = selectedWellClone.gasInMeterDiameter == null ? "None" : String(selectedWellClone.gasInMeterDiameter);
        confirmationString = confirmationString + " \n " + "Gas In Meter Diameter: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasInPlateSize'].value !== this.selectedWell.gasInPlateSize) {
        selectedWellClone.gasInPlateSize = this.editWellInfoFrm.controls['gasInPlateSize'].value;
        oldValue = this.selectedWell.gasInPlateSize == null ? "None" : String(this.selectedWell.gasInPlateSize)
        newValue = selectedWellClone.gasInPlateSize == null ? "None" : String(selectedWellClone.gasInPlateSize);
        confirmationString = confirmationString + " \n " + "Gas In Plate Size: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasInPlateCoefficient'].value !== this.selectedWell.gasInPlateCoefficient) {
        selectedWellClone.gasInPlateCoefficient = this.editWellInfoFrm.controls['gasInPlateCoefficient'].value;
        oldValue = this.selectedWell.gasInPlateCoefficient == null ? "None" : String(this.selectedWell.gasInPlateCoefficient);
        newValue = selectedWellClone.gasInPlateCoefficient == null ? "None" : String(selectedWellClone.gasInPlateCoefficient);
        confirmationString = confirmationString + " \n " + "Gas In Plate Coefficient: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['gasInSpringSize'].value !== this.selectedWell.gasInSpringSize) {
        selectedWellClone.gasInSpringSize = this.editWellInfoFrm.controls['gasInSpringSize'].value;
        oldValue = this.selectedWell.gasInSpringSize == null ? "None" : String(this.selectedWell.gasInSpringSize);
        newValue = this.editWellInfoFrm.controls['gasInSpringSize'].value == null ? "None" : String(selectedWellClone.gasInSpringSize)
        confirmationString = confirmationString + " \n " + "Gas In Spring Size: " + oldValue + " => " + newValue;
      }
      if (this.editWellInfoFrm.controls['notes'].value !== this.selectedWell.notes) {
        selectedWellClone.notes = this.editWellInfoFrm.controls['notes'].value;
        oldValue = this.selectedWell.notes == null ? "None" : this.selectedWell.notes;
        confirmationString = confirmationString + " \n " + "Notes: " + oldValue + " => " + selectedWellClone.notes;
      }
      if (this.editWellInfoFrm.controls['newleasenumber'].value !== this.selectedWell.leaseNumber) {
        selectedWellClone.leaseNumber = this.editWellInfoFrm.controls['newleasenumber'].value;
        oldValue = this.selectedWell.leaseNumber == null ? "" : this.selectedWell.leaseNumber;
        confirmationString = confirmationString + " \n " + "Lease#: " + oldValue + " => " + selectedWellClone.leaseNumber;
      }
      if (this.editWellInfoFrm.controls['newserialnumber'].value !== this.selectedWell.serialNumber) {
        selectedWellClone.serialNumber = this.editWellInfoFrm.controls['newserialnumber'].value;
        oldValue = this.selectedWell.serialNumber == null ? "" : this.selectedWell.serialNumber;
        confirmationString = confirmationString + " \n " + "Serial#: " + oldValue + " => " + selectedWellClone.serialNumber;
      }
      if (this.editWellInfoFrm.controls['newapinumber'].value !== this.selectedWell.api) {
        selectedWellClone.api = this.editWellInfoFrm.controls['newapinumber'].value;
        oldValue = this.selectedWell.api == null ? "" : this.selectedWell.api;
        confirmationString = confirmationString + " \n " + "API#: " + oldValue + " => " + selectedWellClone.api;
      }
      if (this.editWellInfoFrm.controls['isGasLiftWell'].value) { selectedWellClone.isGasLiftWell = 1 }
      if (!this.editWellInfoFrm.controls['isGasLiftWell'].value) { selectedWellClone.isGasLiftWell = 0 }
      returnWellArray.push(selectedWellClone);
    }
    if (this.multiWell) {
      if (form.controls["StatusID"].value !== "noChange") {
        confirmationString = confirmationString + " \n " + "Status: " + this.getStatusName(Number(form.controls["StatusID"].value));
      }
      if (this.editWellInfoFrm.controls['checkHydrate'].value == true) {
        if (this.editWellInfoFrm.controls['StatusID'].value == 1) {
          confirmationString = confirmationString + " \n " + "Create the well data up to available dates for each well.";
        } else {
          confirmationString = confirmationString + " \n " + "Delete the well data up to available dates for each well.";
        }
      }
      if (form.controls["BatteryID"].value !== "noChange") {
        confirmationString = confirmationString + " \n " + "Battery: " + this.getBatteryName(Number(form.controls["BatteryID"].value));
      }
      if (form.controls["GasFacilityID"].value !== "noChange") {
        confirmationString = confirmationString + " \n " + "Gas Facility: " + this.getGasFacilityName(Number(form.controls["GasFacilityID"].value));
      }
      if (form.controls["swdid"].value !== "noChange") {
        confirmationString = confirmationString + " \n " + "SWD: " + this.getSWDName(Number(form.controls["swdid"].value));
      }
        
      confirmationString += form.controls["notes"].value == null ? " \n Notes: " : " \n Notes: " + form.controls["notes"].value;

      this.selectedWellList.forEach(well => {
        add = Object.assign({}, well);
        let date: Date = this.editWellInfoFrm.controls['EffectiveDate'].value;
        add.startDate = date;
        add.injectionWell = well.injectionWell;
        dirty = false;
        add.notes = form.controls["notes"].value;

        if (this.sameField) {
          if (form.controls["StatusID"].value !== "noChange") {
            dirty = true;
            add.currentStatusID = form.controls["StatusID"].value;
            add.currentStatusName = this.getStatusName(Number(form.controls["StatusID"].value));

          }
          if (form.controls["BatteryID"].value !== "noChange") {
            dirty = true;
            add.batteryID = form.controls["BatteryID"].value;
            add.batteryName = this.getBatteryName(Number(form.controls["BatteryID"].value));

          }
          if (form.controls["GasFacilityID"].value !== "noChange") {
            dirty = true;
            add.gasFacilityID = form.controls["GasFacilityID"].value;
            add.gasFacilityName = this.getGasFacilityName(Number(form.controls["GasFacilityID"].value));

          }
          if (form.controls["swdid"].value !== "noChange") {
            dirty = true;
            add.swdid = form.controls["swdid"].value;
            add.swdName = this.getSWDName(Number(form.controls["swdid"].value));
          }
        }
        else if (!this.sameField) {
          if (form.controls["StatusID"].value !== "noChange") {
            dirty = true;
            add.currentStatusID = form.controls["StatusID"].value;
            add.currentStatusName = this.getStatusName(Number(form.controls["StatusID"].value));
          }
        }

        if (dirty) {
          returnWellArray.push(add);
        } else {

        }
      });
    }
    this.wellConFirmString = confirmationString;
    return returnWellArray;
  }

  disableSubmit() {
    let disable: boolean = true;
    if (!this.multiWell) {
      if (this.editWellInfoFrm.controls['StatusID'].value == this.selectedWell.currentStatusID && this.checkEffectiveDate()) {
        if (this.selectedWell.batteryID == null || this.selectedWell.batteryID == 0) {
          if (this.editWellInfoFrm.controls['BatteryID'].value != 0 && this.editWellInfoFrm.controls['BatteryID'].value != null) {
            disable = false;
          } else {
            disable = true;
          }
        } else {
          if (this.editWellInfoFrm.controls['BatteryID'].value != this.selectedWell.batteryID) {
            disable = false;
          } else {
            disable = true;
          }
        }
      }
      if (this.editWellInfoFrm.controls['StatusID'].dirty && (this.editWellInfoFrm.controls['StatusID'].value != this.selectedWell.currentStatusID) && this.checkEffectiveDate()) {
        if (this.editWellInfoFrm.controls['StatusID'].value != 6 && (null == this.editWellInfoFrm.controls['BatteryID'].value || this.editWellInfoFrm.controls['BatteryID'].value == 0)) {
          disable = true;
        } else {
          disable = false;
        }     
      }
      else if (this.editWellInfoFrm.controls['BatteryID'].value != this.selectedWell.batteryID && this.checkEffectiveDate()) {
        if (this.editWellInfoFrm.controls['StatusID'].dirty && this.editWellInfoFrm.controls['StatusID'].value != this.selectedWell.currentStatusID) {
          disable = false;
  
        }
        else {
          if (this.editWellInfoFrm.controls['BatteryID'].value != 0 && this.editWellInfoFrm.controls['BatteryID'].value != null) {
            disable = false;
          } 
        }
      }
      else if (this.editWellInfoFrm.controls['GasFacilityID'].dirty && (this.editWellInfoFrm.controls['GasFacilityID'].value != this.selectedWell.gasFacilityID) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['swdid'].dirty && (this.editWellInfoFrm.controls['swdid'].value != this.selectedWell.swdid) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['isGasLiftWell'].dirty && (this.editWellInfoFrm.controls['isGasLiftWell'].value != this.selectedWell.isGasLiftWell) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['gasOutMeterDiameter'].dirty && (this.editWellInfoFrm.controls['gasOutMeterDiameter'].value != this.selectedWell.gasOutMeterDiameter)
        && this.editWellInfoFrm.controls['gasOutPlateSize'].dirty && (this.editWellInfoFrm.controls['gasOutPlateSize'].value != this.selectedWell.gasOutPlateSize) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['gasOutPlateCoefficient'].dirty && (this.editWellInfoFrm.controls['gasOutPlateCoefficient'].value != this.selectedWell.gasOutPlateCoefficient) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['gasOutSpringSize'].dirty && (this.editWellInfoFrm.controls['gasOutSpringSize'].value != this.selectedWell.gasOutSpringSize) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['gasInMeterDiameter'].dirty && (this.editWellInfoFrm.controls['gasInMeterDiameter'].value != this.selectedWell.gasInMeterDiameter)
        && this.editWellInfoFrm.controls['gasInPlateSize'].dirty && (this.editWellInfoFrm.controls['gasInPlateSize'].value != this.selectedWell.gasInPlateSize) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['gasInPlateCoefficient'].dirty && (this.editWellInfoFrm.controls['gasInPlateCoefficient'].value != this.selectedWell.gasInPlateCoefficient) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['gasInSpringSize'].dirty && (this.editWellInfoFrm.controls['gasInSpringSize'].value != this.selectedWell.gasInSpringSize) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['newleasenumber'].dirty && (this.editWellInfoFrm.controls['newleasenumber'].value != this.selectedWell.leaseNumber) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['newserialnumber'].dirty && (this.editWellInfoFrm.controls['newserialnumber'].value != this.selectedWell.serialNumber) && this.checkEffectiveDate()) {
        disable = false;
      }
      else if (this.editWellInfoFrm.controls['newapinumber'].dirty && (this.editWellInfoFrm.controls['newapinumber'].value != this.selectedWell.api) && this.checkEffectiveDate()) {
        disable = false;
      }
    }
    else {
      if (this.editWellInfoFrm.controls['StatusID'].dirty  && this.checkEffectiveDate()) {
        if (this.editWellInfoFrm.controls['StatusID'].value != 6 && (null == this.editWellInfoFrm.controls['BatteryID'].value && this.sameField || this.editWellInfoFrm.controls['BatteryID'].value == 0)) {
          disable = true;
        } else {
          disable = false;
        }
      }
      else if (this.editWellInfoFrm.controls['BatteryID'].dirty && this.checkEffectiveDate()) {
        if (this.editWellInfoFrm.controls['StatusID'].dirty ) {
          disable = false;
        }
        else if (this.editWellInfoFrm.controls['StatusID'].value != 6 && null == this.editWellInfoFrm.controls['BatteryID'].value && this.sameField) {
          disable = true;
        }
        else {
          disable = false;
        }
      }

      else if (this.editWellInfoFrm.controls['GasFacilityID'].dirty && this.editWellInfoFrm.controls['EffectiveDate'].dirty) {
         disable = false;
      }
      else if (this.editWellInfoFrm.controls['swdid'].dirty && this.editWellInfoFrm.controls['EffectiveDate'].dirty) {
         disable = false;
      }
      else if (this.editWellInfoFrm.controls['isGasLiftWell'].dirty && this.editWellInfoFrm.controls['EffectiveDate'].dirty) {
         disable = false;
      }
      if (this.wellsSelectedCount == 0) {
        disable = true;
      }

      this.selectedWellList.forEach(well => {
        if (well.batteryID == null || well.batteryID == 0) {
          this.oneWellDrilling = true;
        }

        if (((this.editWellInfoFrm.controls["BatteryID"].value == null || this.editWellInfoFrm.controls["BatteryID"].value == "noChange") && this.oneWellDrilling == true && this.editWellInfoFrm.controls["StatusID"].value != 6)) {
          disable = true;
        } else {
          disable = false;
        }
      })
    }

    if (null == this.editWellInfoFrm.controls['StatusID'].value) {
      disable = true;
    }

    

    if (this.editWellInfoFrm.controls["BatteryID"].value == "noChange" && this.editWellInfoFrm.controls["StatusID"].value == "noChange") {
      if (this.editWellInfoFrm.controls["GasFacilityID"].value == "noChange" && this.editWellInfoFrm.controls["swdid"].value == "noChange") {
        disable = true;
      } else {
        disable = false;
      }
    }
    return disable;
  }

  checkEffectiveDate() {
    let check: boolean = false;
    if (null != this.selectedWell && null != this.selectedWell.startDate) {
      let testDate = new Date(this.selectedWell.startDate.toDateString());
      testDate.setDate(this.selectedWell.startDate.getDate() + 1);
      if (testDate.toDateString() == this.todaysDate.toDateString()) {
        check = true;
      }
      else {
        if (this.editWellInfoFrm.controls['EffectiveDate'].value != undefined) {
          if (this.editWellInfoFrm.controls['EffectiveDate'].valid && this.editWellInfoFrm.controls['EffectiveDate'].value.toDateString() != this.selectedWell.startDate.toDateString()) {  //changed dirty to valid
            check = true;
          }
          else {
            check = false;
          }
          if (this.selectedWell.startDate.toDateString() == this.todaysDate.toDateString()) {
            check = false;
          }
        }
      }
    }
    else {
      if (this.editWellInfoFrm.controls['EffectiveDate'].valid ) {  //changed dirty to valid
        check = true;
      }
      else {
        check = false;
      }
    }
    return check;
  }


  checkSpringSize(i: boolean) {
    
    if (i) {
      if ( this.selectedWell.gasInSpringSize == null) {
        return null;
      }
      return this.selectedWell.gasInSpringSize;
    }
    else {
      if ( this.selectedWell.gasOutSpringSize == null) {
        return null;
      }
      return this.selectedWell.gasOutSpringSize;
    }
   
  }

  hideChangeIndicator(controlName: string) {
    let show: boolean = false;
    if (this.multiWell) {
      if (controlName == 'EffectiveDate') {
        if (null != this.editWellInfoFrm.controls[controlName].value) {
          show = true;
        }
      }
      else if (controlName == 'notes') {
        if (this.editWellInfoFrm.controls[controlName].value != null && this.editWellInfoFrm.controls[controlName].value !="") {
          show = true;
        }
      }
      else {
        if (this.editWellInfoFrm.controls[controlName].value != "noChange") {
          show = true;
        }
      }
    }
    else {
      if (controlName == 'EffectiveDate') {
        if (null != this.editWellInfoFrm.controls[controlName].value) {
          if (null != this.selectedWell.startDate) {
            if (this.editWellInfoFrm.controls[controlName].value.toDateString() != this.selectedWell.startDate.toDateString()) {
              show = true;
            }
          } else {
            show = true;
          }
        }
      }
      else if (controlName == 'StatusID') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.currentStatusID) {
          show = true;
        }
      }
      else if (controlName == 'BatteryID') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.batteryID) {
          show = true;
        }
      }
      else if (controlName == 'GasFacilityID') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasFacilityID) {
          show = true;
        }
      }
      else if (controlName == 'swdid') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.swdid) {
          show = true;
        }
      }
      else if (controlName == 'isGasLiftWell') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.isGasLiftWell) {
          show = true;
        }
      }
      else if (controlName == 'gasOutMeterDiameter') {
        let originalGasOutMeterDiameter = Math.round(this.selectedWell.gasOutMeterDiameter) == 0 ? null : Math.round(this.selectedWell.gasOutMeterDiameter)
        if (this.editWellInfoFrm.controls[controlName].value != originalGasOutMeterDiameter) {
          show = true;
        }
      }
      else if (controlName == 'gasOutPlateSize') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasOutPlateSize) {
          show = true;
        }
      }
      else if (controlName == 'gasOutPlateCoefficient') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasOutPlateCoefficient) {
          show = true;
        }
      }
      else if (controlName == 'gasOutSpringSize') {
        if (this.editWellInfoFrm.controls[controlName].value == "") { this.editWellInfoFrm.patchValue({ 'gasOutSpringSize': null }); }
        if ((this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasOutSpringSize)){
          show = true;
        }
      }
      else if (controlName == 'gasInMeterDiameter') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasInMeterDiameter) {
          show = true;
        }
      }
      else if (controlName == 'gasInPlateSize') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasInPlateSize) {
          show = true;
        }
      }
      else if (controlName == 'gasInPlateCoefficient') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasInPlateCoefficient) {
          show = true;
        }
      }
      else if (controlName == 'gasInSpringSize') {
        if (this.editWellInfoFrm.controls[controlName].value == "") { this.editWellInfoFrm.patchValue({ 'gasInSpringSize': null });}
        if ((this.editWellInfoFrm.controls[controlName].value != this.selectedWell.gasInSpringSize)) {
          show = true;
        }
      }
      else if (controlName == 'notes') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.notes) {

          show = true;
        }
      }
      else if (controlName == 'newapinumber') {
        if (String(this.editWellInfoFrm.controls[controlName].value).trim() != this.returnNullOrTrimmedValue(this.selectedWell.api)) {
          show = true;
        }
      }
      else if (controlName == 'newleasenumber') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.leaseNumber) {
          show = true;
        }
      }
      else if (controlName == 'newserialnumber') {
        if (this.editWellInfoFrm.controls[controlName].value != this.selectedWell.serialNumber) {
          show = true;
        }
      }
    }

    return show;
  }

  displayWarning() {
    if (null != this.selectedWell && null != this.selectedWell.startDate) {
      let testDate = new Date(this.selectedWell.startDate.toDateString());
      testDate.setDate(this.selectedWell.startDate.getDate() + 1);
      if (testDate.getTime() > this.todaysDate.getTime()) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  filterSelectedWells() {

    if (this.search == "checked:true") {
      this.search = "";
    }
    else {
      this.search = "checked:true";
    }
    this.config.currentPage = 1
  }

  toggleLoader(id: string, hide: boolean) {
    let ele = document.getElementById(id);
    if (null != ele) {
      ele.hidden = hide;
    }
  }

  setPlateDiameterDropDown(plateDiameter: number | null, gasIn: boolean, wellCloned: boolean) {
    let id: string = "gasOutPlateLoader";
    let originalGasInPlateDiameter = this.selectedWell['gasInMeterDiameter']
    let originalGasInPlateSize = this.selectedWell['gasInPlateSize']
    let originalGasOutPlateDiameter = Math.round(this.selectedWell['gasOutMeterDiameter'])
    let originalGasOutPlateSize = this.selectedWell['gasOutPlateSize']
    try {
      if (gasIn) { id = "gasInPlateLoader"; }
      this.toggleLoader(id, false);
      if (null == plateDiameter) {
        if (gasIn) {
          this.gasInPlateSize = <any>[];
          this.editWellInfoFrm.patchValue({ 'gasInPlateCoefficient': null, 'gasInPlateSize': null });
        }
        else {
          this.gasOutPlateSize = <any>[];
          this.editWellInfoFrm.patchValue({ 'gasOutPlateCoefficient': null, 'gasOutPlateSize': null });
        }
      }
      else {
        let plate = this.wellPlateInfo.find(i => i.plateDiameter === Math.round(plateDiameter));
        if (gasIn) {
          this.gasInPlateSize = plate.plateSizeCoef;
          if (!wellCloned) {
            this.editWellInfoFrm.patchValue({ 'gasInPlateCoefficient': null, 'gasInPlateSize': null });
          }
          else {
            this.editWellInfoFrm.patchValue({ 'gasInPlateCoefficient': null });
            if (originalGasInPlateDiameter !== this.editWellInfoFrm.value['gasInMeterDiameter'] || originalGasInPlateSize !== this.editWellInfoFrm.value['gasInPlateSize']) {
              this.editWellInfoFrm.controls['gasInPlateSize'].markAsDirty();
              this.editWellInfoFrm.controls['gasInPlateCoefficient'].markAsDirty();
            }
          }
        }
        else {
          this.gasOutPlateSize = plate.plateSizeCoef;
          if (!wellCloned) {
            this.editWellInfoFrm.patchValue({ 'gasOutPlateCoefficient': null, 'gasOutPlateSize': null });
          }
          else {
            this.editWellInfoFrm.patchValue({ 'gasOutPlateCoefficient': null });
            if (originalGasOutPlateDiameter !== this.editWellInfoFrm.value['gasOutMeterDiameter'] || originalGasOutPlateSize !== this.editWellInfoFrm.value['gasOutPlateSize']) {
              this.editWellInfoFrm.controls['gasOutPlateSize'].markAsDirty();
              this.editWellInfoFrm.controls['gasOutPlateCoefficient'].markAsDirty();
            }
          }
        }
      }
      this.toggleLoader(id, true);
    } catch (err) {
      console.log(err);
      this.toggleLoader(id, true);
    }
  }

  setPlateSizeCoef(plateDiameter: number | null, plateSize: number | null, gasIn: boolean) {
    let id: string = "gasOutPlateCoefLoader";
    let originalGasInPlateDiameter = this.selectedWell['gasInMeterDiameter']
    let originalGasInPlateSize = this.selectedWell['gasInPlateSize']
    let originalGasOutPlateDiameter = Math.round(this.selectedWell['gasOutMeterDiameter'])
    let originalGasOutPlateSize = this.selectedWell['gasOutPlateSize']
    try {
      if (gasIn) { id = "gasInPlateCoefLoader"; }
      this.toggleLoader(id, false);
      if (null == plateSize) {
        if (gasIn) {
          this.editWellInfoFrm.patchValue({ 'gasInPlateCoefficient': null });
          if (originalGasInPlateDiameter !== this.editWellInfoFrm.value['gasInMeterDiameter'] || originalGasInPlateSize !== this.editWellInfoFrm.value['gasInPlateSize'])
          {
            this.editWellInfoFrm.controls['gasInPlateCoefficient'].markAsDirty();
          }
        } else {
          this.editWellInfoFrm.patchValue({ 'gasOutPlateCoefficient': null });
          if (originalGasOutPlateDiameter !== this.editWellInfoFrm.value['gasOutMeterDiameter'] || originalGasOutPlateSize !== this.editWellInfoFrm.value['gasOutPlateSize'])
          {
            this.editWellInfoFrm.controls['gasOutPlateCoefficient'].markAsDirty();
          }
        }
      }
      else {
        let plate = this.wellPlateInfo.find(i => i.plateDiameter === Math.round(plateDiameter));
        if (typeof plate != "undefined") {
          let plateSizes = plate.plateSizeCoef.find((p: any) => p.plateSize === plateSize);
          if (typeof plateSizes != "undefined") {
            if (gasIn) {
              this.editWellInfoFrm.patchValue({ 'gasInPlateCoefficient': plateSizes['plateCoef'] });
              if (originalGasInPlateDiameter !== this.editWellInfoFrm.value['gasInMeterDiameter'] || originalGasInPlateSize !== this.editWellInfoFrm.value['gasInPlateSize'])
              {
                this.editWellInfoFrm.controls['gasInPlateCoefficient'].markAsDirty();
              }  
            } else {
              this.editWellInfoFrm.patchValue({ 'gasOutPlateCoefficient': plateSizes['plateCoef'] });
              if (originalGasOutPlateDiameter !== this.editWellInfoFrm.value['gasOutMeterDiameter'] || originalGasOutPlateSize !== this.editWellInfoFrm.value['gasOutPlateSize'])
              {
                this.editWellInfoFrm.controls['gasOutPlateCoefficient'].markAsDirty();
              }
            }
          }
        }
      }

      this.toggleLoader(id, true);
    }
    catch (err) {
      console.log(err);
      this.toggleLoader(id, true);
    }
  }

  validPlateSize() {
    if ((null != this.editWellInfoFrm.controls['gasOutMeterDiameter'].value && null == this.editWellInfoFrm.controls['gasOutPlateSize'].value ) ||
      (null != this.editWellInfoFrm.controls['gasInMeterDiameter'].value && null == this.editWellInfoFrm.controls['gasInPlateSize'].value) ) {
      return true;
    }
    return false;
  }

  validBatteryID(control: any) {
    if (control.value) {
      return null;
    }
  }

  pageChanged(number:number) {
    if (number != -1) {
      this.config.currentPage = number;
    }
  }

  goToCreateWellPage(mode: string) {
    localStorage.setItem("wellMode", mode);
    if (mode == "editMode" && this.selectedWellList.length == 1)
    { localStorage.setItem("wellid", JSON.stringify(this.selectedWellList[0].wellID)); }
    else { localStorage.setItem("wellid", null); }
    this.router.navigate([this.router.url + '/add']);
  }

}

interface WellObj {
  fieldID: number;
  fieldName: string;
  wellID: number;
  wellName: string;
  currentStatusID: number;
  currentStatusName: string;
  startDate: Date | null;
  endDate: Date | null;
  api: string;
  luw: string;
  serialNumber: string;
  leaseNumber: string;
  batteryName: string;
  batteryID: number;
  gasFacilityID: number;
  gasFacilityName: string;
  notes: string;
  swdid: number;
  swdName: string;
  gasOutMeterDiameter: number;
  gasOutPlateSize: number;
  gasOutPlateCoefficient: number;
  gasOutSpringSize: number;
  gasInMeterDiameter: number;
  gasInPlateSize: number;
  gasInPlateCoefficient: number;
  gasInSpringSize: number;
  injectionWell: boolean;
  isGasLiftWell: number;
}

interface WellObjCheck extends WellObj {
  isChecked: boolean;
}



